export default function initmesserueckmeldung(){
    var multiperson = $(".multiperson");
    var multiDummy = multiperson.find(".multiperson__dummy .multiperson__person");
    var multiList = multiperson.find(".multiperson__list");
    var multiCount = multiperson.find(".multiperson__count");
    var multiButton = multiperson.find(".multiperson__changecount");
    var multiInput = multiperson.find(".multiperson__input");
    multiCount.val(multiList.find(".multiperson__person").length);

    multiButton.on("click", function (e) {
        e.preventDefault();
        var newCount = parseInt(multiCount.val());
        if (newCount === "" || newCount < 1 || newCount > 50) {
            return;
        }
        var currentPersonList = multiList.find(".multiperson__person");
        var currentCount = currentPersonList.length;
        if (newCount === currentPersonList.length) {
            return;
        }
        else if (newCount < currentCount) {
            for (var x = newCount; x < currentCount; x++) {
                currentPersonList.eq(x).remove();
            }
        }
        else if (newCount > currentCount) {
            var currentCount = currentPersonList.length;
            for (var x = currentCount; x < newCount; x++) {
                var newInput = multiDummy.clone();
                multiList.append(newInput);
            }
        }

        var personNumber = 1;
        multiList.find(".multiperson__number").each(function () {
            $(this).text(personNumber);
            personNumber++;
        });
        serializePersons();
    });
    multiCount.on("keydown", function (e) {
        if (e.key === "Enter") {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
        }

    });

    function serializePersons() {
        multiInput.val("");
        var persons = [];
        multiList.find(".multiperson__person").each(function () {
            var person = [];
            $(this).find("input").each(function () {
                person.push($(this).val().replace(/;/g, "").replace(/§/g, ""));
            });
            persons.push(person.join(";"));
        });
        console.log(persons);

        multiInput.val(persons.join("§"));
        console.log(multiInput.val());
    }

    multiList.on("keyup", "input", function (e) {
        serializePersons();
        if (e.key === "Enter") {
            e.stopPropagation();
            e.preventDefault();
        }
    });
}

